// extracted by mini-css-extract-plugin
export default {"brand_small_slider":"style_brand_small_slider__mRKgI","brand_small_banners_item":"style_brand_small_banners_item__yo3MQ","slider_image":"style_slider_image__W4Vsk"};